import type AppState from "../AppState";

export const selectCustomizationData = (state: AppState) => state.tenancyCustomization.customizationData;

export const selectCustomizationResult = (state: AppState) => state.tenancyCustomization.getCustomizationResult;

export const selectCustomizationLoading = (state: AppState) => state.tenancyCustomization.loading;
